<template>
  <v-container>
    <h1 class="mt-1 mb-5">המודולים שלנו:</h1>
    <v-row>
      <v-col class="col-md-4 col-xs-1" v-for="item in items" :key="item">
        <v-card :to="`/module/${item.id}/`" height="100%">
          <v-img :src="item.img" height="150" ></v-img>
          <v-card-title class="text-wrap">{{item.title}}</v-card-title>
          <v-card-text class="text-wrap">{{item.subTitle}}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text :to="`/module/${item.id}/`">קרא עוד <v-icon small class="mr-1">mdi-arrow-left</v-icon></v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  export default {
    
    data: () => ({
      items: [
        
      ],
    }),
    methods: {
      importData() {
        function getJsonFromServer(url, cb) {
            fetch(url, { method: "GET" })
                .then((responseText) => {
                    return responseText.json();
                })
                .then((jsonObject) => {
                    cb(jsonObject);
          });
        }
        getJsonFromServer(`/items.json`, (responseText) => {
          this.items = responseText.items.reverse();
        });
      }
    },
    beforeMount () {
      this.importData();
      document.title = "דף הבית - מודולי API";
    }
  }
</script>